import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { IntegrationsHubRedirect } from "../integrations-hub-redirect";

export const orderTrackingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("General");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "order-tracking",
    lazy: async () => {
      const { OrderTrackingSettings } =
        await import("../../../../setting/order-tracking/order-tracking-settings");
      return { Component: OrderTrackingSettings };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Integrations");
      },
      permission: SettingsPermissions.SET_MARKETING_SETTINGS,
    },
    path: "order-tracking-integrations",
    element: <IntegrationsHubRedirect to="../integrations" />,
  },
];
